import React, { useState } from "react";
import KC_Heading2 from "../../designsystem/typography/KC-Heading/KC_Heading2";
import Separator from "../../components/Separator";
import { tt } from "../../utils/i18n/i18n";

export default function ColorTest() {
  const [brightnessThreshold, setBrightnessThreshold] = useState(128);
  const [colors, setColors] = useState([
    "#FFFFFF",
    "#000000",
    "#FF0000",
    "#00FF00",
    "#0000FF",
    "#ff0054",
    "#00ffff"
  ]);

  return (
    <div className="d-flex flex-column p-4 st-gap">
      <Separator />
      <Separator />
      <KC_Heading2 text={tt("color_test_title")} />
      <div className="d-flex flex-column st-gap">
        <label className="d-flex flex-row align-content-center">
          Seuil de couleur sombre de la couleur de fond : {brightnessThreshold}
          <input
            className="ml-2"
            type="range"
            min="0"
            max="255"
            value={brightnessThreshold}
            onChange={(e) => setBrightnessThreshold(Number(e.target.value))}
          />
        </label>
        <div className="d-flex flex-column st-gap">
          {colors.map((color, index) => {
            const isDark = isColorDark(color, brightnessThreshold);
            return (
              <div className="d-flex flex-row st-gap w-50 align-items-center">
                <div className="">
                  <input
                    className="form-control"
                    onChange={(e) => {
                      const newColors = [...colors];
                      newColors[index] = e.target.value;
                      setColors(newColors);
                    }}
                    value={color}
                  />
                </div>
                <button
                  key={index}
                  style={{
                    backgroundColor: color,
                    color: isDark ? "white" : "black",
                    padding: "1rem",
                    border: "1px solid #ccc"
                  }}
                >
                  Button {index + 1}
                </button>
                <span>
                  {isDark
                    ? tt("color_test_primary")
                    : tt("color_test_secondary")}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export function isColorDark(color?: string, threshold: number = 128) {
  if (!color) {
    return false;
  }

  // Create a temporary DOM element to parse the color
  const el = document.createElement("div");
  el.style.color = color;
  el.style.visibility = "hidden";
  document.body.appendChild(el);

  const computedColor = getComputedStyle(el).color;
  document.body.removeChild(el);

  // Match "rgb(r, g, b)" or "rgba(r, g, b, a)"
  const match = computedColor.match(
    /rgba?\((\d+), (\d+), (\d+)(?:, ([\d.]+))?\)/
  );
  if (!match) throw new Error(`Invalid color: ${color}`);

  let [_, r, g, b, a] = match.map(Number);
  a = a === undefined ? 1 : a;

  // Blend with white background if transparent
  if (a < 1) {
    r = Math.round((1 - a) * 255 + a * r);
    g = Math.round((1 - a) * 255 + a * g);
    b = Math.round((1 - a) * 255 + a * b);
  }

  // Perceived brightness formula
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b;

  // Threshold: <128 is dark, >=128 is light
  return brightness < threshold;
}
